export default __webpack_public_path__ + "static/media/balance.b118a12a.svg";